import React, { useState } from "react";
import styled from "styled-components";
import {
  useAreaGenerateStore,
  useEventStore,
  usePathStore,
  usePointStore,
} from "../../Store/store";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* 더 높은 z-index 설정 */
`;

const ModalContainer = styled.div`
  background-color: #1a1a1a;
  border-radius: 12px;
  padding: 30px 25px;
  width: 460px;
  max-width: 90vw;
  color: #fff;
  box-sizing: border-box;
`;

const ModalTitle = styled.h2`
  margin: 0 0 20px 0;
  color: #fff;
  font-size: 24px;
  text-align: center;
  font-weight: 600;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
  box-sizing: border-box;
  width: 100%;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #fff;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #333;
  border-radius: 6px;
  background-color: #2a2a2a;
  color: #fff;
  font-size: 14px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #00ff99;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 30px;
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;

  &.create {
    background-color: rgba(0, 255, 153, 0.1);
    color: #00ff99;
    border: 1px solid #00ff99;

    &:hover {
      background-color: #00ff99;
      color: #000;
    }
  }

  &.cancel {
    background-color: transparent;
    color: #ff6b6b;
    border: 1px solid #ff6b6b;

    &:hover {
      background-color: #ff6b6b;
      color: #fff;
    }
  }
`;

export default function ObstacleModal() {
  const {
    obstacleModal,
    setObstacleModal,
    eachObstaclePoints,
    setAllObstaclePoints,
    allObstaclePoints,
    setShowOverlay,
    setEachObstaclePoints,
    setObstacleMode,
    areaModeIdList,
  } = usePathStore();
  const { selectedAreaType, selectedAreaColor } = useAreaGenerateStore();
  const { obstacleInfo } = usePointStore();
  const [obstacleName, setObstacleName] = useState("");
  const [obstacleDescription, setObstacleDescription] = useState("");
  const { viewer } = usePathStore();
  const { cancelObstacle } = useEventStore();
  const { closedObstacleArea, setClosedObstacleArea } = usePathStore();

  const handleCreate = () => {
    if (!obstacleName.trim()) {
      alert("장애물 이름을 입력해주세요.");
      return;
    }
    const typeName = areaModeIdList.find(
      (area) => area.id === selectedAreaType
    ).typeName;

    // 장애물 데이터 생성
    const obstacleData = {
      type: typeName,
      areaTypeId: selectedAreaType,
      color: selectedAreaColor,
      id: eachObstaclePoints.id,
      name: obstacleName,
      description: obstacleDescription,
      points: eachObstaclePoints.points,
      markers: eachObstaclePoints.markers,
      // renderObjects: eachObstaclePoints.renderObjects,
      lines: eachObstaclePoints.lines,
      polygons: eachObstaclePoints.polygons,
      all: eachObstaclePoints.all,
      timestamp: Date.now(),
    };

    setAllObstaclePoints([...allObstaclePoints, obstacleData]);

    // 모달 닫기 및 상태 초기화
    setObstacleMode(false);
    setObstacleModal(false);
    setObstacleName("");
    setObstacleDescription("");
    setShowOverlay(false);
    setEachObstaclePoints([]);
  };

  const handleCancel = () => {
    if (obstacleInfo) {
      const toRemove = [];
      viewer.scene.scene.traverse((obj) => {
        if (
          obj.userData?.obstacleId === obstacleInfo ||
          obj.userData?.markerId === obstacleInfo
        ) {
          toRemove.push(obj);
        }
      });
      toRemove.forEach((obj) => {
        viewer.scene.scene.remove(obj);
        if (obj.geometry) obj.geometry.dispose();
        if (obj.material) obj.material.dispose();
      });

      // 상태에서도 제거
      const newAllObstaclePoints = allObstaclePoints.filter(
        (obstacle) => obstacle.id !== obstacleInfo
      );
      setAllObstaclePoints(newAllObstaclePoints);

      const newClosedObstacleArea = closedObstacleArea.slice(0, -1); // 마지막 추가된 것 제거
      setClosedObstacleArea(newClosedObstacleArea);
    }

    setObstacleMode(false);
    setObstacleModal(false);
    setObstacleName("");
    setObstacleDescription("");
    setShowOverlay(false);
    setEachObstaclePoints([]);
  };

  if (!obstacleModal) return null;

  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalTitle>영역 정보 입력</ModalTitle>

        <FormGroup>
          <Label>영역 이름 (필수)</Label>
          <Input
            type="text"
            value={obstacleName}
            onChange={(e) => setObstacleName(e.target.value)}
            placeholder="예: 나무, 바위, 건물 등"
            maxLength={50}
            required
          />
        </FormGroup>

        <FormGroup>
          <Label>영역 설명</Label>
          <Input
            type="text"
            value={obstacleDescription}
            onChange={(e) => setObstacleDescription(e.target.value)}
            placeholder="영역에 대한 간단한 설명"
            maxLength={50}
            required
          />
        </FormGroup>

        <ButtonContainer>
          <Button className="create" onClick={handleCreate}>
            생성
          </Button>
          <Button className="cancel" onClick={handleCancel}>
            취소
          </Button>
        </ButtonContainer>
      </ModalContainer>
    </ModalOverlay>
  );
}
